import { useMemo } from "react";
import { CLASH_FORCE_SINGLE_SESSION, getOtherEditors } from "../roundabout-utilities";

import type { PanicSituationFirstExitDict, RoundaboutRoomUser } from "../roundabout-markings";

export const useFirstExitSignpost = (
  mySub: string,
  initialUsers: RoundaboutRoomUser[],
): {
  panicSituation: keyof PanicSituationFirstExitDict | null;
} =>
  useMemo(() => {
    // Process the list of current attendees to find a known onStart panic situation
    // otherwise keep calm and carry on

    // Priority given to selfAlreadyEditing, but ensure only showing one dialog at a time

    // This will keep effecting if there are updates coming in whilst the user has the dialog open
    // That is ok as the situation will either :
    // - stay with the same dialog (OK)
    // - switch from selfAlreadyEditing to othersAlreadyEditing (which is OK)
    // - close the dialog and set themselves as editor (also OK)

    // Panic situation 1: We are already editing
    // look for ourself by comparing key/userIds
    if (
      CLASH_FORCE_SINGLE_SESSION &&
      initialUsers.some(
        (initialUser) => initialUser.userId === mySub && initialUser.role === "Editing",
      )
    ) {
      return {
        panicSituation: "self-already-editing",
      };
    }

    // Panic situation 2: Someone else is already editing
    if (getOtherEditors(initialUsers, mySub).length > 0) {
      return {
        panicSituation: "others-already-editing",
      };
    }

    // All is quiet. Announce our presence.
    return {
      panicSituation: null,
    };
    // Close the dialog if it was open
  }, [mySub, initialUsers]);
